import { getCurrentInstance } from 'vue-demi';

export default function useRouter() {
  return getCurrentInstance().proxy.$router;
}
